import { useEffect } from 'react';
import { useAppStore } from './stores/appStore';
import {
  connectRealtime,
  disconnectRealtime,
  onRealtime,
  onRealtimeStatus,
} from './lib/realtime';
import { LoginScreen } from './components/auth/LoginScreen';
import { Dashboard } from './components/layout/Dashboard';
import { BurnInProtection } from './components/BurnInProtection';
import { SeasonOverlay } from './components/season/SeasonOverlay';
import { HourlyShow } from './components/season/HourlyShow';
import { useKioskIdle } from './hooks/useKioskIdle';

export default function App() {
  const ready = useAppStore((s) => s.ready);
  const user = useAppStore((s) => s.user);
  const kiosk = useAppStore((s) => s.kiosk);
  const init = useAppStore((s) => s.init);
  const applyRealtime = useAppStore((s) => s.applyRealtime);
  const setConnected = useAppStore((s) => s.setConnected);

  useKioskIdle(kiosk);

  useEffect(() => {
    void init();
  }, [init]);

  useEffect(() => {
    connectRealtime();
    const offMsg = onRealtime((ev) => applyRealtime(ev.type, ev.payload));
    const offStatus = onRealtimeStatus((st) => setConnected(st === 'open'));
    return () => {
      offMsg();
      offStatus();
      disconnectRealtime();
    };
  }, [applyRealtime, setConnected]);

  const shell = !ready ? (
    <div className="flex h-full items-center justify-center bg-slate-950">
      <div className="text-center">
        <div className="mx-auto mb-4 h-12 w-12 animate-pulse rounded-2xl bg-violet-500/30" />
        <p className="text-lg text-slate-400">Loading Fink Family…</p>
      </div>
    </div>
  ) : !user ? (
    <LoginScreen />
  ) : (
    <>
      <Dashboard />
      {/* Burn-in protection: DVD-style clock after 5 min idle (pointer-events: none) */}
      <BurnInProtection />
    </>
  );

  return (
    <>
      <SeasonOverlay />
      {user && <HourlyShow />}
      {shell}
    </>
  );
}
